import { useState } from "react";
import Card from "../UI/Card";
import Button from "../UI/Button";
import Title from "../UI/Title";
import Text from "../UI/Text";
import AddressForm, { type AddressFormValues } from "./AddressForm";
// @ts-expect-error pure js
import useAccount from "../../hooks/use-account";
import styles from "./AddressFacturation.module.css";

export default function AddressFacturation() {
  const [isFormOpen, setIsFormOpen] = useState(false);
  const { account, hasValidAddress, updateCompte } = useAccount();

  async function saveAddress(values: AddressFormValues) {
    await updateCompte(values);
    setIsFormOpen(false);
  }

  return (
    <Card className={styles.card}>
      <AddressForm
        open={isFormOpen}
        onOpenChange={setIsFormOpen}
        account={account}
        onSubmit={saveAddress}
      />
      <div className={styles.header}>
        <Title variant="kilo">Adresse de facturation</Title>
        <Button
          type="button"
          variant="secondary"
          onClick={() => setIsFormOpen(true)}
        >
          {hasValidAddress ? "Modifier" : "Ajouter une adresse de facturation"}
        </Button>
      </div>
      <div>
        <Text>{account.nom}</Text>
        <Text>{account.adresse}</Text>
        {account.complement_adresse && (
          <Text>{account.complement_adresse}</Text>
        )}
        <Text>
          {account.cp} {account.ville}
        </Text>
      </div>
    </Card>
  );
}
